const en = {
  'register': {
    'title': 'Register and enjoy the exclusive rights and interests of enterprise members',
    'many_hotel': 'Super many hotels',
    'many_hotel_desc': 'More than 7500 cities and more than 1 million hotels in the world',
    'best_sel': 'Optimal choice',
    'best_sel_desc': 'Integrate and compare global suppliers to provide the best choice',
    'service_guarantee': 'Service guarantee',
    'service_guarantee_desc': '7 x 15 hours of service to quickly verify inventory and quotations',
    'home_page': 'home',
    'register': 'Register',
    'existing_account': 'Existing account, log in now',
    'account_info': 'Account information',
    'user_name': 'user name',
    'enter_user_name': 'Enter one user name',
    'password': 'password',
    'enter_password': 'Please input a password',
    'confirm_password': 'confirm password',
    'enter_confirm_password': 'Please enter the password again',
    'enterprise_information': 'Enterprise information',
    'company_name': 'company name',
    'enter_company_name': 'Please enter company name',
    'city': 'city',
    'sel_city': 'Please select your city',
    'business_license': 'business license',
    'upload_business_license': 'Please upload your business license',
    'contact_information': 'Contact information',
    'name': 'your name',
    'enter_name': 'Please enter your name',
    'enter_real_name': 'Please fill in your real name',
    'phone_number': 'phone number',
    'enter_phone_number': 'Please enter your mobile phone number',
    'enter_common_phone': 'Please fill in your common mobile phone number, which can be used for login',
    'mailbox': 'your mailbox',
    'enter_mailbox': 'Please enter email',
    'enter_common_mailbox': 'Please fill in the common mailbox to retrieve the password',
    'already_read': 'I have read and agreed to the',
    'terms_of_ervice': '《Terms of Service》',
    'privacy_policy': '《Privacy Policy》',
    'and': 'and',
    'submit_registration': 'Submit registration',
    'register_success': 'login was successful',
    'thanks_register': 'Thank you for your registration application. We will complete the review within 1-2 working days. Please wait patiently!',
    'go_home_page': 'Return to the home page'
  },
  'login': {
    'login': 'Login',
    'user_name': 'user name',
    'enter_user_name': 'Enter one user name',
    'password': 'password',
    'enter_password': 'Please input a password',
    'login_btn': 'Login',
    'code_login': 'login by user name',
    'forgot_password': 'Forgot password?',
    'register_now': 'Register now,',
    'get_hotels': 'Instant access to massive global hotel resources',
    'phone_number': 'phone number',
    'enter_phone_number': 'Please enter your mobile phone number',
    'verify': 'verify',
    'enter_verify': 'Please enter the verify code',
    'get_verify': 'Get verify code',
    'verify_login': 'login by verify'
  },
  'header': {
    'logo': 'More room reservation options',
    'booking': 'Booking',
    'order': 'Orders',
    'order_center': 'Order Center',
    'person_center': 'Person Center',
    'loginOut': 'Login Out',
    'Reminder': 'Reminder',
    'confirm_login_out': 'Whether to exit the current account',
    'confirm': 'confirm',
    'cancel': 'cancel'
  },
  'search': {
    'destination': 'Destination',
    'sel_city': 'Please select a city',
    'checkIn': 'Check In',
    'checkOut': 'Check Out',
    'night': 'Night',
    'rooms_and_guests': 'Rooms,Guests',
    'room': 'Rooms',
    'Adult': 'Number of adults (per room)',
    'key_word': 'Key Word',
    'enter_key_word': 'Please enter keywords',
    'searchBtn': 'Search',
    'hot_chain': 'Domestic hot cities',
    'hot_oversea': 'Overseas hot cities',
    'southeast_asia': 'Southeast Asia',
    'Asia': 'Asia',
    'America': 'America',
    'Europe': 'Europe',
    'Oceanica': 'Oceanica',
    'middle_east_africa': 'Middle East/Africa'
  },
  'hotel_list': {
    'unlimited': 'unlimited',
    'downtown': 'downtown',
    'district': 'district',
    'below_two_stars': 'Below two stars',
    'three_star': 'Three-star',
    'four_star': 'Four-star',
    'five_star': 'Five-star',
    'less_than_200': 'Less than 200 yuan',
    '200_500': '200~500 yuan',
    '500_1000': '500~1000 yuan',
    '1000_2000': '1000~2000 yuan',
    'more_than_2000': 'More than 2000 yuan',
    'current': 'Currently',
    'hotel_counts': 'hotels meet the conditions and have filtered out hotels without quotation for you',
    'no_hotels': 'There are no hotels at present, please search again with another condition',
    'view_details': 'view details',
    'location': 'Location',
    'hotel_stars': 'Hotel stars',
    'price_per_night': 'Price per night'
  },
  'hotel_detail': {
    'show_map': 'Consult The Map',
    'Opening': 'Opening',
    'see_more': 'See More',
    'all_facilities': 'View all hotel facilities',
    'Room_type_reservation': 'Room type reservation',
    'checkIn': 'Check In',
    'checkOut': 'Check Out',
    'number_of_rooms': 'Number of rooms',
    'Occupancy': 'Number of guests',
    'update': 'Update',
    'bed_type': 'bed type',
    'breakfast': 'breakfast',
    'king_bed': 'king Bed',
    'Double_bed': 'Double Bed',
    'Single_bed': 'Single Bed',
    'Large_double_bed': 'Large Double Bed',
    'has_breakfast': 'Including breakfast',
    'Single_breakfast': 'Single breakfast',
    'Double_breakfast': 'Double breakfast',
    'All_room_types': 'All room types',
    'Room_type_and_room_description': 'Room type and room description',
    'meals': 'meals',
    'Cancel_the_policy': 'Cancel the policy',
    'Average_price_room_night': 'Average price/room/night',
    'book': 'book',
    'the_lowest_price': 'The lowest price',
    'Breakfast_not_included': 'Breakfast not included',
    'Including_text': 'Including',
    'breakfast_count': 'breakfast',
    'no_cancel': 'Not Cancellable',
    'Free_cancellation_before': 'Free cancellation before',
    'total': 'Total price',
    'Book_Now': 'Book',
    'Hotel_introduction': 'Hotel introduction',
    'follow_info': 'The following information is based on the hotel data for your reference.',
    'Hotel_telephone': 'Hotel telephone',
    'Chinese_address': 'Chinese address',
    'English_address': 'English address',
    'Hotel_Profile': 'Hotel Profile',
    'Hotel_facilities': 'Hotel facilities',
    'fac_info': 'Due to the possible adjustment of hotel facilities, the information is not updated enough. Please subject to the actual check-in.',
    'Hotel_location': 'Hotel location'
  },
  'booking': {
    'please': 'Please complete the form within',
    'complete': 'to avoid the room being booked or the price changing',
    'minutes': 'minutes and',
    'seconds': 'seconds',
    'Fill_in': 'Fill in check-in information',
    'Entry_and_departure_time': 'Entry and departure time',
    'to': 'to',
    'Your_order_number': 'Your order number',
    'room': 'room',
    'guest': 'guest',
    'last_name': 'last name',
    'first_name': 'first name',
    'keep_common': 'Please keep consistent with the certificate',
    'contact_information': 'Contact information',
    'name': 'name',
    'Select_contacts': 'Select contacts',
    'phone_number': 'phone number',
    'email': 'mailbox',
    'send_email': 'The information will be sent to this mailbox',
    'attentions': 'Attentions',
    'Booking_prompt': 'Booking prompt',
    'info_confirm': 'The order shall take effect after the hotel or supplier confirms it. The order confirmation result shall be subject to the SMS or email notification. If the order is not confirmed, the credit limit will be automatically refunded or the full amount will be refunded to your payment account.',
    'info_price': 'The prices shown do not include any applicable accommodation service charges, optional miscellaneous charges (such as mini-bar snacks or phone calls) or additional charges stipulated by the hotel. The hotel will calculate these expenses and surcharges when you check out.',
    'info_get': 'The reservation service is provided by Cozytime, Ltd. and its partners, the accommodation service is provided by the hotel, and the transaction fee is collected by Ketan Technology.',
    'Change_or_cancel': 'Change or cancel',
    'change_info': 'After the order is confirmed, if you need to change the order information, including the name of the check-in person, date, bed type, etc., please contact Cotan customer service to confirm whether it can be modified.',
    'Not_arriving_or_late': 'Not arriving or late',
    'late_info': 'If the order cannot arrive at the hotel on the first night or is delayed, please contact the Cotan customer service, otherwise the hotel may not notify the guest in any way, and cancel the entire order directly without refunding the charged booking fee.',
    'Payment_information': 'Payment information',
    'yuan': 'yuan',
    'Total_payables': 'Total payables',
    'read': 'I have read the travel tips and cost instructions, and accept the',
    'Reservation_terms': 'Reservation terms',
    'Next_pay': 'Next, pay',
    'Reservation_information': 'Reservation information',
    'Expense_details': 'Expense details',
    'The_room_rate': 'The room rate'
  },
  'cashier': {
    'order_will': 'The order will be closed automatically after',
    'order_close': 'Please complete the payment as soon as possible!',
    'order_num': 'Order number',
    'Total_order_amount': 'Total order amount',
    'Credit_limit': 'Credit limit',
    'Current_available_credit': 'Current available credit',
    'Alipay': 'Alipay',
    'Immediate_payment': 'Immediate payment',
    'Room_type_number_of_rooms': 'Room type-number of rooms'
  },
  'center': {
    'Account_Center': 'Account Center',
    'Hotel_order': 'Hotel order',
    'Hotel_bill_details': 'Hotel bill details',
    'Account_information': 'Account information',
    'Account_settings': 'Account settings',
    'contact_management': 'Contact management',
    'Sub_account_management': 'Sub-account management',
    'Order_status': 'Order status',
    'all': 'All',
    'Processing': 'Processing',
    'Confirmed': 'Confirmed',
    'Canceled': 'Canceled',
    'Full_house': 'Full house',
    'Order_Close': 'Order Close',
    'Created': 'Created',
    'fill_in_order_num': 'Cozytime order number/your order number',
    'Date_selection': 'Date selection',
    'Reservation_date': 'Reservation date',
    'Date_of_check_in': 'Date of check-in',
    'Start_date': 'Start date',
    'End_date': 'End date',
    'orders': 'Order No./Confirmation No.',
    'hotel_room_name': 'Hotel name/room type name',
    'Order_time': 'Order time',
    'Order_amount': 'price',
    'check_in_out': 'Check in/out',
    'operation': 'Operation',
    'no_data': 'No data',
    'Cozytime_order': 'Cozytime order',
    'your_order': 'your order',
    'confirmation_number': 'confirmation number',
    'Unpaid': 'Unpaid',
    'Paid': 'Paid',
    'Refunded': 'Refunded',
    'To_be_paid': 'To be paid',
    'detail': 'Detail',
    'order_detail': 'Order details',
    'room_type': 'Room type',
    'Reservation_time': 'Reservation time',
    'contact_text': 'Contact',
    'contact_number': 'Contact number',
    'Payment_method': 'Payment method',
    'Country_name': 'Country name',
    'Hotel_City': 'Hotel City',
    'Hotel_telephone': 'Hotel telephone',
    'hotels_address': 'hotel\'s address',
    'Latest_cancellation_time': 'Latest cancellation time',
    'Hotel_bill': 'Hotel bill',
    'Transaction_time': 'Transaction time',
    'year': 'year',
    'month': 'month',
    'day': 'day',
    'Select_Year': 'Select Year',
    'Transaction_type': 'Transaction type',
    'Order_amount': 'Order amount',
    'Transaction_date': 'Transaction date',
    'Credit_line_payment': 'Credit line payment',
    'Alipay_payment': 'Alipay payment',
    'WeChat_payment': 'WeChat payment',
    'Recharge': 'Recharge',
    'Consumption': 'Consumption',
    'Refund': 'Refund',
    'User_information': 'User information',
    'user_name': 'user name',
    'Enterprise_information': 'Enterprise information',
    'Enterprise_No': 'Enterprise No.',
    'Enterprise_name': 'Enterprise name',
    'status': 'status',
    'normal': 'normal',
    'abnormal': 'abnormal',
    'City': 'City',
    'Credit_balance': 'Credit balance',
    'Settlement_method': 'Settlement method',
    'Single_settlement': 'Single settlement',
    'Monthly_settlement': 'Monthly settlement',
    'Recharge_information': 'Recharge information',
    'Alipay_transfer': 'The first type: Alipay transfer',
    'bank_transfer': 'Second type: bank transfer',
    'collection_account': 'Party A\'s collection account',
    'account_name': 'Party A\'s account name',
    'Change_Password': 'Change Password',
    'Current_password': 'Current password',
    'old_password': 'Please enter the old password',
    'New_password': 'New password',
    'letters_numbers': 'Composed of 6-20 letters or numbers, starting with a letter',
    'Confirm_Password': 'Confirm Password',
    'password_again': 'Please enter the password again',
    'enter_new_password': 'Please enter a new password',
    'password_format': 'Please enter the correct password format',
    'passwords_differ': 'Entered passwords differ',
    'save': 'save',
    'confirm_change': 'Are you sure you want to change the password?',
    'login_again': 'The password has been changed, please log in again',
    'Modified_successfully': 'Modified successfully',
    'Modify_mailbox': 'Modify mailbox',
    'Current_mailbox': 'Current mailbox',
    'mailbox_format': 'Please enter the correct mailbox format',
    'confirm_email': 'Are you sure you want to modify the mailbox?',
    'emial_change_success': 'Mailbox modified successfully',
    'Top_contacts': 'Top contacts',
    'New_reservation_contact': 'New reservation contact',
    'New_contact': 'New contact',
    'Modify_contact_information': 'Modify contact information',
    'modify': 'modify',
    'delete': 'delete',
    'phone_formatter': 'Please enter the correct phone format',
    'New_contact': 'New contact',
    'confirm_del': 'Are you sure you want to delete this contact?',
    'Delete_succeeded': 'Delete succeeded',
    'Successfully_added': 'Successfully added',
    'Add_sub_account': 'Add sub-account',
    'Employee_name': 'Employee name',
    'del_emp': 'Are you sure you want to delete the employee account?',
    'our_service': 'OUR SERVICE',
    'HOTEL_RECOMMENDATION': 'HOTEL RECOMMENDATION',
    'confirm_cancel': 'Are you sure to cancel the order?',
    'cancel_failed': 'Cancel failed. Please try again later',
    'commit_cancel': 'The application has been submitted, please check later',
    'customer_phone': 'Customer service telephone numbers',
    'customer_email': 'Customer service mailbox',
    'oa_account': 'WeChat official account',
    'applet': 'Hotel reservation applet'
  }
}

export default en;


// WEBPACK FOOTER //
// ./src/lang/en.js